<template>
	<div>
		<new-type-form class="mb-4"/>
		<level-types-list
			:columns="columns"
			:rows="rows"
		/>
	</div>
</template>
<script>
import newTypeForm from '@/components/configuration/types/new-type-form';
import levelTypesList from '@/components/configuration/types/level-types-list';

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nivel', value: 'level', flagVisible: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', flagVisible: true, visible: true },
			{ id: 3, name: 'Acciones', value: 'actions', flagVisible: true, visible: true },
		],
		rows: [
			{ level: 1, name: 'Criterio' },
			{ level: 2, name: 'Factores' },
		],
	};
}

export default {
	name: 'page-level-types',
	data,
	components: {
		levelTypesList,
		newTypeForm,
	},
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-level-types.vue